import { styled } from '@mui/system';
import { DataGridPro } from '@mui/x-data-grid-pro';
import { SPACING } from 'src/layouts/dashboard/Main';
import { HEADER } from 'src/config-global';
import {
  getBackgroundColor,
  getHoverBackgroundColor,
  getSelectedBackgroundColor,
  getSelectedHoverBackgroundColor,
} from 'src/utils/cssStyles';

interface DataGridProProps {
  isDesktop: boolean;
  breadcrumbHeight?: number;
  tabHeight?: number;
  additionalHeight?: number;
}

export const StyleDataGridPro = styled(DataGridPro, {
  shouldForwardProp: (prop) =>
    prop !== 'isDesktop' &&
    prop !== 'breadcrumbHeight' &&
    prop !== 'tabHeight' &&
    prop !== 'additionalHeight',
})<DataGridProProps>(({ theme, isDesktop, breadcrumbHeight, tabHeight, additionalHeight }) => ({
  '&.MuiDataGrid-root .MuiDataGrid-main': {
    // 248px - main padding bottom, breadcrumb margin bottom, table select bar height, table search height, table footer
    height: `calc(100vh - (${HEADER.H_MOBILE + SPACING}px + ${breadcrumbHeight || 0}px + ${tabHeight || 0}px + ${additionalHeight || 0}px + 248px))`,
    ...(isDesktop && {
      // HEADER.H_DASHBOARD_DESKTOP + SPACING - main padding top
      // 230px - main padding bottom, breadcrumb margin bottom, table select bar height, table search height, table footer
      height: `calc(100vh - (${HEADER.H_DASHBOARD_DESKTOP + SPACING}px + ${breadcrumbHeight || 0}px + ${tabHeight || 0}px + ${additionalHeight || 0}px + 230px))`,
    }),
  },
  '& .shown-in-map': commonRowStyles(theme, theme.palette.info.main),
  '& .focus-in-map': commonRowStyles(theme, theme.palette.error.main),
  '& .partial': commonRowStyles(theme, theme.palette.error.light),
  '& .complete': commonRowStyles(theme, theme.palette.success.main),
  ...commonCellStyles,
}));

export const commonCellStyles = {
  '& .align-cell-center': {
    display: 'flex',
    alignItems: 'center',
  },
  '& .align-cell-right': {
    alignItems: 'right',
    textAlign: 'right',
  },
};

export const commonRowStyles = (theme: any, color: string) => ({
  backgroundColor: getBackgroundColor(color, theme.palette.mode),
  '&:hover': {
    backgroundColor: getHoverBackgroundColor(color, theme.palette.mode),
  },
  '&.Mui-selected': {
    backgroundColor: getSelectedBackgroundColor(color, theme.palette.mode),
    '&:hover': {
      backgroundColor: getSelectedHoverBackgroundColor(color, theme.palette.mode),
    },
  },
});
